module.exports = __webpack_public_path__ + "static/img/logo.5aaa3e0.png";